"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const async_1 = __importDefault(require("react-select/async"));
const formik_1 = require("formik");
const MultiselectField = ({ label, ...props }) => {
    const [field, meta, helpers] = (0, formik_1.useField)(props);
    const { id } = props;
    const { touched, error, value } = meta;
    const { setValue } = helpers;
    const { getOptionValue } = props;
    return (react_1.default.createElement("div", { className: "space-y-1" },
        react_1.default.createElement("label", { htmlFor: id, className: "block text-sm font-medium text-gray-700" }, label),
        react_1.default.createElement(async_1.default, { ...props, name: field.name, onChange: (value) => setValue(getOptionValue(value)) }),
        touched && error ? react_1.default.createElement("p", { className: "mt-2 text-sm text-red-600", id: "email-error" }, error[0]) : ''));
};
exports.default = MultiselectField;
